export function useCustomMeta(path, year, month, day, canonicalPath) {
  const route = useRoute()
  const config = useRuntimeConfig()
  const baseUrl = `${config.public.hostDomain}${config.app.baseURL}`
  const pageUrl = `${baseUrl}${route.path.replace(/^\//, '')}`
  const tdConfig = makeTdConfig(year, month, day)
  const ogImageUrl = () => {
    if (path.startsWith('chart')) {
      return `https://gvs.weathernews.jp/common/images/ogp/past_chart@1x.png`
    } else if (path.startsWith('satellite')) {
      return `https://gvs.weathernews.jp/common/images/ogp/past_satellite@1x.png`
    }
  }

  useSeoMeta({
    ogImage: ogImageUrl(),
    ogType: 'website',
    ogSiteName: 'ウェザーニュース',
    viewport: 'width=device-width,initial-scale=1.0,minimum-scale=1.0,maximum-scale=3.0,user-scalable=yes',
    twitterCard: 'summary_large_image',
    twitterSite: '@wni_jp',
    twitterCreator: '@wni_jp',
    fbAppId: '1500388770270212',
    appleItunesApp: 'app-id=302955766',
    appleMobileWebAppCapable: 'yes',
    formatDetection: 'address=no'
  })
  useSeoMeta({
    title: `${tdConfig[path].title} - ウェザーニュース`,
    description: tdConfig[path].description,
    ogTitle: `${tdConfig[path].title} - ウェザーニュース`,
    ogDescription: tdConfig[path].description,
    ogUrl: pageUrl,
    appleMobileWebAppTitle: `${tdConfig[path].title}`,
    keywords: `${tdConfig[path].keyword},ウェザーニュース`
  })
  useHead({
    link: [
      { rel: 'canonical', href: `${baseUrl}${canonicalPath.replace(/^\//, '')}` },
      { rel: 'preconnect', href: config.public.siteDataDomain, crossorigin: 'anonymous' },
      { rel: 'preconnect', href: 'https://mws.cdn.weathernews.jp', crossorigin: 'anonymous' },
      { rel: 'dns-prefetch', href: config.public.siteDataDomain },
      { rel: 'dns-prefetch', href: config.public.imgDomain }
    ]
  })
}
